import React from 'react';
import {
  Button,
  Card,
  CardHeader
} from 'reactstrap';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import qualitystore from '../stores/QualityStore';

const closeModal = () => {
  qualitystore.setOpenModal();
}

const resetForm = () => {
  qualitystore.clearIncidentForm();
  qualitystore.setOpenModal();
  qualitystore.disablePages();
}

const ErrorWindowComponent = props => {
  const {
    errorCount
  } = props;

  return (
    <>
      <Card>
        <CardHeader className="errorPopup d-flex justify-content-center flex-column align-items-center center-text">
          {
            errorCount > 0 ?
            <>
              <h5>
                <b>
                  The Incident Report that was posted has failed to send.
                </b>
              </h5>
              <div className="spacer" />
              <h6>Hit <b>submit</b> again</h6>
              <Button className="errCloseBtn" onClick={() => closeModal()} type="button" color="default">
                OK
              </Button>
            </>
            :
            <>
              <h5>
                <b>
                  The Incident Report that was posted has failed to send.
                </b>
              </h5>
              <div className="spacer" />
              <h6>Please try again sometime later.</h6>
              <NavLink exact to="/" onClick={() => resetForm()} className="btn errCloseBtn btn-default">
                OK
              </NavLink>
            </>
          }
        </CardHeader>
      </Card>
    </>
  )
}

ErrorWindowComponent.propTypes = {
  errorCount: PropTypes.number
}

export default ErrorWindowComponent;